module.exports = __webpack_public_path__ + "static/mlekolaki-7d3bce03472caed9d0077a831fbb7856.png";